<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <v-row class="ma-0 mt-5 mb-4">
        <v-col class="pa-0 my-4">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #000000;">{{ "Historial de conversiones" }}</div>
          <div style="font-family: 'montserrat-regular'; font-size: 14px;"> {{ "Aqui encontraras el historial de todas tus conversiones realizadas." }}</div>
        </v-col>
      </v-row>
      <v-row justify="start" align="center" class="d-flex ma-0 mb-4">
        <v-col class="d-flex pl-0 py-0">
          <div style="width: 286px;">
            <v-autocomplete
              label="Selecciona un usuario"
              :items="users"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              clearable
              class="mr-2"
              item-value="sCustomerEnterpriseId"
              item-text="sName"
              @change="getConversionsHistory()"
              v-model="selectedUser"
            ></v-autocomplete>
          </div>
          <div style="width: 186px;">
            <v-autocomplete
              label="Moneda origen"
              :items="currency"
              hide-details
              style="font-family: 'montserrat-medium'; border-radius: 20px;"
              outlined
              clearable
              class="mr-2"
              item-value="value"
              item-text="text"
              @change="getConversionsHistory()"
              v-model="selectedCurrency"
            ></v-autocomplete>
          </div>
        </v-col>
        <v-col class="d-flex justify-end pa-0 my-4">
          <v-btn color="#000000" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSX()">
            <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
            {{ "Descargar" }}
          </v-btn>
        </v-col>
      </v-row>
      <v-data-table class="d-none d-sm-block" hide-default-header :items="items">
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">{{ "Id" }}</th>     
              <th class="header__title center">{{ "Usuario" }}</th>                                                                                                                                                                                    
              <th class="header__title center">{{ "Fecha de creación" }}</th>
              <th class="header__title center">{{ "Tipo de transaccion" }}</th>                                                                                                                                                                                                                          
              <th class="header__title center">{{ "Fecha de vencimiento" }}</th>
              <th class="header__title center">{{ "Tipo de cambio" }}</th>
              <th class="header__title center">{{ "Monto origen" }}</th>
              <th class="header__title center">{{ "Monto destino" }}</th>
              <th class="header__title center">{{ "Spread" }}</th>
              <th class="header__title center">{{ "Revenue" }}</th>
              <th class="header__title center">{{ "Fresher coins" }}</th>
              <th class="header__title center">{{ "Status" }}</th>
              <th class="header__title right">{{ "Acciones" }}</th>
            </tr>
          </thead>
        </template>
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.sTransactionId }}</td>
              <td class="table__item">{{ item.CustomerEnterprises }}</td>
              <td class="table__item">{{ formatDate(item.created_at) }}</td>
              <td class="table__item">
                <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined style="background-color: #FDF0F5 !important; border-width: 1.5px;">
                  {{ "Forward" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" class="ma-2" color="#2397C7" outlined style="background-color: #F0F8FE !important; border-width: 1.5px;">
                  {{ "Forex" }}
                </v-chip>
                <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="#FB0075" outlined style="background-color: #FDEBEB !important; border-width: 1.5px;">
                  {{ "Window spot" }}
                </v-chip>
                <v-chip v-else class="ma-2" color="orange" outlined style="background-color: #FDF8EB !important; border-width: 1.5px;">
                  {{ "Pay now" }}
                </v-chip>
              </td>
              <td class="table__item">{{ item.dForwardTransactionDate ? formatDate(item.dForwardTransactionDate) : "-" }}</td>
              <td class="table__item">{{  "$ " + formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate) + " MXN" }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</td>
              <td class="table__item">{{ "$ " + formatMoney(item.dDesAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</td>
              <td class="table__item">{{ parseFloat(item.spread).toFixed(6).replace(/\.?0+$/, '') + "%" }}</td>
              <td class="table__item">{{ "$" + formatMoney(item.re) + " USD" }}</td>
              <td class="table__item">{{ "-" }}</td>
              <td class="table__item">{{ item.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227' ? "Concretada" : (item.sStatusId == '5833e33c-3468-4f3d-b3de-d227500955e3' ? "Pendiente" : (item.sStatusId == '679d409d-8fa9-404c-8fc7-9352e198c072' ? "Pendiente" : "-" )) }}</td>
              <td class="table__item">
                <v-btn
                  icon
                  small
                  @click="viewConversionDetail(item.sTransactionId)"
                  style="color: #000000;"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
                <v-tooltip top v-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn @click="getReceipt(item)" v-bind="attrs" v-on="on" icon color="black">
                      <v-icon>mdi-invoice-text-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Descargar comprobante</span>
                </v-tooltip>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
      <v-data-table class="d-sm-none d-block" hide-default-header :items="items">
        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd; width: 100%;">
            <tr style="display: flex; flex-direction: column;" v-for="item in items" :key="item.id">
              <td class="table__item__mobile">
                <div>{{ "Id" }}</div>
                <div>{{ item.sTransactionId }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Usuario" }}</div>
                <div>{{ item.CustomerEnterprises }}</div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de creación" }}</div>
                <div>{{ formatDate(item.created_at) }}</div>              
              </td>
              <td class="table__item__mobile">
                <div>{{ "Tipo de transaccion" }}</div>
                <div>
                  <v-chip v-if="item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3'" class="ma-2" color="red" outlined>
                    {{ "Forward" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a'" class="ma-2" color="blue" outlined>
                    {{ "Forex" }}
                  </v-chip>
                  <v-chip v-else-if="item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf'" class="ma-2" color="green" outlined>
                    {{ "Spot window" }}
                  </v-chip>
                  <v-chip v-else class="ma-2" color="orange" outlined>
                    {{ "Pay now" }}
                  </v-chip>
                </div>
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fecha de vencimiento" }}</div>
                <div>{{ item.dForwardTransactionDate ? formatDate(item.dForwardTransactionDate) : "-" }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Tipo de cambio" }}</div>
                <div>{{  "$ " + formatMoney(item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate) + " MXN" }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto origen" }}</div>
                <div>{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "USD") }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Monto destino" }}</div>
                <div>{{ "$ " + formatMoney(item.dDesAmount) + " " + (item.sDestCurrency ? item.sDestCurrency : "MXN") }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Currency profit ($)" }}</div>
                <div>{{ "-" }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Currency profit (%)" }}</div>
                <div>{{ "-" }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Revenue" }}</div>
                <div>{{ "-" }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Fresher Coins" }}</div>
                <div>{{ "-" }}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Status" }}</div>
                <div>{{ item.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227' ? "Concretada" : (item.sStatusId == '679d409d-8fa9-404c-8fc7-9352e198c072' ? "Pendiente" : ((item.sStatusId == '4291b132-d28b-4b52-844a-77e4216857aa' ? "Finalizada" : item.sStatusId == '94bbc2b7-6e31-4523-b438-58c1987a907b' ? "Abierta" : "N/A")))}}</div> 
              </td>
              <td class="table__item__mobile">
                <div>{{ "Acciones" }}</div>
                <div>
                  <v-btn
                    icon
                    small
                    @click="viewConversionDetail(item.sTransactionId)"
                    style="color: #000000;"
                  >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </div>
              </td>
              <v-divider></v-divider>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <v-dialog v-model="showDetailDialog" max-width="1400px" scrollable>
        <v-card>
          <v-card-text class="pa-0">
            <ConversionDetailContent
              v-if="selectedTransactionId"
              :s-transaction-id="selectedTransactionId"
              @close="showDetailDialog = false"
              @go-to-payment="goToPayment"
              @go-to-invoice="goToInvoice"
            />
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import moment from "moment";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import ConversionDetailContent from "./ConversionDetailContent.vue";

export default {
  name: "DashboardView",
  components: {
    ConversionDetailContent,
  },
  data() {
    return {
      nameXLSX: "HistorialConversiones.xlsx",
      users: [],
      selectedUser: "",
      isLoading: false,
      items: [],
      currency: [
        { text: "USD", value: "USD" },
        { text: "MXN", value: "MXN" },
      ],
      selectedCurrency: "",
      showDetailDialog: false,
      selectedTransactionId: null,
    };
  },
  methods: {
    getUsers() {
      this.isLoading = true;
      DB.get(`${URI}/api/v1/en/administrator/users`, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      }).then((response) => {
        this.users = response.data.results
        this.isLoading = false;
      }).catch((error) => {
          // this.isLoading = false;
          if (error.response.data.code) {
            this.$router.push("/welcome").catch(() => {});
          }
          this.mixError(error.response.data.message, error.response.status);
        });
    },
    getConversionsHistory() {
      this.isLoading = true;

      const payload = {
        sEnterpriseId: this.selectedUser,
        sCurrency: this.selectedCurrency
      };

      DB.post(`${URI}/api/v1/en/administrator/conversions`, payload, {
        headers: {
          Authorization: this.$store.state.sToken
            ? `Bearer ${this.$store.state.sToken}`
            : ""
        }
      })
      .then((response) => {
        this.items = response.data.transactions
        this.isLoading = false;
      }).catch((error) => {
        if (error.response.data.code) {
          this.$router.push("/welcome").catch(() => {});
        }
        this.mixError(error.response.data.message, error.response.status);
      });
    },
    formatMoney: function (value) {
      let multiplied = value * 100;
      let rounded = Math.round(multiplied);
      let formattedNumber = rounded / 100;
      return new Intl.NumberFormat("en-US", {
        style: "decimal",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(formattedNumber);
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("DD-MM-YYYY");
      return formattedDate;
    },
    dataXLSX() {
      try {
        let data = this.items.map((item) => {
          return {
            Id: item.iTrackingId ? item.iTrackingId : "",
            Usuario: item.CustomerEnterprises ? item.CustomerEnterprises : "",
            Beneficiario: item.CustomerEnterprises ? item.CustomerEnterprises : "",
            "Fecha de creación": item.created_at ? this.formatDate(item.created_at) : "",
            "Type Transaction": item.sTransactionType == 'b80e8dc6-4138-449e-8903-968efb8437b3' ? 'Forward' : (item.sTransactionType == 'e7b157eb-8dcb-4655-8d0e-4eb4e7e9270a' ? 'Forex' : (item.sTransactionType == '484a23d2-7dc1-4fd0-a1b0-3402d066c2cf' ? 'Spot window' : "Pay Now")),
            "Due date": item.dForwardTransactionDate ? this.formatDate(item.dForwardTransactionDate) : "",
            "Exchange rate": item.dExchangeRate ? item.dExchangeRate < 1 ? 1 / item.dExchangeRate : item.dExchangeRate : "",
            "Moneda origen": item.sCurrency ? item.sCurrency : "USD",
            "Moneda destino": item.sDestCurrency ? item.sDestCurrency : "MXN",
            "Monto origen": item.dAmount ? parseFloat(item.dAmount) : "",
            "Monto destino": item.dDesAmount ? parseFloat(item.dDesAmount) : "",
            Status:  item.sStatusId == '5a792637-1103-4a89-8f67-86c49b93e227' ? "Concretada" : "Pendiente",
            "Spread": item.spread ? parseFloat(item.spread).toFixed(6).replace(/\.?0+$/, '') + "%" : "",
            "Revenue": item.re ? parseFloat(item.re) : "",
          };
        });
        const worksheet = XLSX.utils.json_to_sheet(data);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Hoja1");

        const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

        const blob = new Blob([excelBuffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });

        saveAs(blob, this.nameXLSX);
        this.success = true;
        this.msgSuccess = "Descargando documento";
      } catch (error) {
        this.error = true;
        this.codeError = "CSV_NO_DATA";
      }
    },
    getReceipt(item) {
      this.loading = true;
      const payload = {
        sConversionId: item.sTransactionId,
        sEnterpriseId: item.sEnterpriseId,
      };

      DB.post(
        `${URI}/api/v1/en/administrator/getReceipt`, payload,
        {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          },
          responseType: 'blob'
        }
      )
      .then((response) => {
        const blob = new Blob([response.data], { type: "application/pdf" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = `${item.PaymentRecipient + (item.invoice ? "_" + item.invoice : "")}.pdf`;
        link.click();
      })
      .catch((error) => {
        this.mixError(
          error?.response?.data?.message || "No se pudo descargar el archivo",
          error?.response?.status || 500
        );
      })
      .finally(() => {
        this.loading = false;
      });
    },
    viewConversionDetail(transactionId) {
      this.selectedTransactionId = transactionId;
      this.showDetailDialog = true;
    },
    goToPayment(item) {
      this.showDetailDialog = false;
      this.$router.push({
        name: "PaymentDetail",
        params: { sPaymentId: item.sPaymentId }
      }).catch(() => {});
    },
    goToInvoice(item) {
      this.showDetailDialog = false;
      this.$router.push({
        name: "InvoiceDetail",
        params: { sInvoiceId: item.invoice.sInvoiceId }
      }).catch(() => {});
    },
  },
  beforeMount() {
    this.getUsers();
    this.getConversionsHistory();
  },
};
</script>

<style>
</style>
